import axios from 'axios'

const endpoints = {
  employee: '/api/v1/imports/employee_attachment',
  asset_v2: '/api/v1/imports/asset_v2_attachment'
}

const appendIfPresent = (formData, key, value) => {
  if (value === undefined || value === null || value === '') return
  formData.append(key, value)
}

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

export const uploadMassiveAttachment = async ({ item, onProgress, signal }) => {
  const endpoint = endpoints[item.resourceType]
  if (!endpoint) throw new Error(`Unsupported massive upload resource: ${item.resourceType}`)

  const formData = new FormData()
  formData.append('file', item.file)
  formData.append('client_upload_id', item.id)
  formData.append('attachment_type_id', item.attachmentTypeId)
  appendIfPresent(formData, 'period_month', item.periodMonth)
  appendIfPresent(formData, 'period_year', item.periodYear)
  appendIfPresent(formData, 'contractor_contract_id', item.contractorContractId)
  appendIfPresent(formData, 'asset_category_id', item.assetCategoryId)
  appendIfPresent(formData, 'asset_type_id', item.assetTypeId)

  const response = await axios.post(endpoint, formData, {
    signal,
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken()
    },
    onUploadProgress: ({ loaded, total }) => {
      if (!total) return
      onProgress(Math.min(100, Math.round((loaded / total) * 100)))
    }
  })

  return response.data
}
